import { isEmpty } from 'lodash';
import { Fragment } from 'react';

/* eslint-disable-next-line */
type FilterGroupProps = {
  filterTitle?: string;
  filterItems: OptionsType[];
  handleSelectFilter: (type: string, value: string, status: boolean) => void;
};

type OptionsType = {
  value: string;
  checked: boolean;
};

export function FilterGroup(props: FilterGroupProps) {
  const { filterTitle, filterItems, handleSelectFilter } = props;

  function handleSelect(e: any) {
    handleSelectFilter(filterTitle as string, e.target.value, e.target.checked);
  }

  const renderFilterTitle = !isEmpty(filterTitle) ? (
    <p className="font-bold text-subtitle pt-4 pb-1 uppercase hidden md:block">
      {filterTitle}
    </p>
  ) : (
    <Fragment />
  );

  const renderFilterItems = filterItems?.map((item) => (
    <>
      <div className="flex-col">
        <input
          type="checkbox"
          checked={item.checked}
          value={item.value}
          onChange={(e) => handleSelect(e)}
        />
        <label className="font-MuseoSans100 pl-2 text-subtitle">
          {item.value}
        </label>
      </div>
    </>
  ));

  return (
    <>
      {renderFilterTitle}
      {renderFilterItems}
    </>
  );
}

export default FilterGroup;
